module.exports = __webpack_public_path__ + "static/img/DSC_0058.b9a23ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_0058.jpg
// module id = 33sc
// module chunks = 0